// extracted by mini-css-extract-plugin
module.exports = {"floating-action-button":"floating-action-button__floating-action-button___2UvYs"};